@let selectedIndex = selectedIndex$ | async;

<h3-feedback-panel dialogTitle="Feedback" (panelClose)="close()">
  <ng-container projection-location="header">
    <button
      *ngIf="isUpdateFeedbackAllowed$ | async"
      mat-icon-button
      (click)="addFeedback()"
    >
      <mat-icon [svgIcon]="addFeedbackIcon.name"></mat-icon>
    </button>
  </ng-container>
  @for (feedback of feedbackItems; track feedback; let index = $index) {
    <h3-feedback-item
      [title]="feedback.errorTag"
      [comment]="feedback.comment"
      [isEditAllowed]="isUpdateFeedbackAllowed$ | async"
      [isDeleteAllowed]="isUpdateFeedbackAllowed$ | async"
      [timestamp]="feedback.updatedAt"
      [selected]="selectedIndex === index"
      (select)="selectFeedback(index)"
      (edit)="editFeedback(index)"
      (delete)="deleteFeedback(index)"
    ></h3-feedback-item>
  }
</h3-feedback-panel>
